import { AHText, Box } from "arkh";
import React from "react";
import { TipArea } from "../../../../../components";
import { WATitleInput } from "../../WidgetAdd/WATitleInput";
import { FormattedMessage } from "react-intl";

export function WANoteSettings(props: {
  title: string;
  setTitle(_: React.SetStateAction<string>): void;
}) {
  return (
    <Box style={{ flex: 1 }} space="medium" spaceTop="medium">
      <WATitleInput value={props.title} onChangeText={props.setTitle} />
      <Box spaceTop="large">
        <TipArea>
          <AHText type="body">
            <FormattedMessage
              defaultMessage="You can change the title and content of a widget after it has been created"
              description="WANoteSettings.Tip"
            />
          </AHText>
        </TipArea>
      </Box>
    </Box>
  );
}
